import React, { useCallback, useState } from 'react';
import { Trans } from 'react-i18next';
import { useUserUpsert } from 'src/hooks/user';
import { useRedirect } from 'src/hooks/utils';
import { notification } from 'src/components/Notification';
import { parseFormErrors } from 'src/utils/api/error';
import { useActivityCreate } from 'src/hooks/activity';
import { USERS } from 'src/routes/routes';

export default isNew => {
  const [redirectUrl, setRedirectUrl] = useRedirect();
  const upsertUser = useUserUpsert(isNew);
  const [showSaveConfirmPopup, setShowSaveConfirmPopup] = useState(false);
  const [paramValues, setValues] = useState(null);

  const createActivity = useActivityCreate();

  const callSave = async (paramsValues) => {
    try{
      const message = isNew ? (
        <Trans>USER_CREATED</Trans>
      ) : (
        <Trans>USER_UPDATED</Trans>
      );
      const { data } = await upsertUser({
        ...paramsValues,
        id: paramsValues.id && +paramsValues.id,
        timezoneId: paramsValues.timezoneId,
        roleIds: paramsValues.roles.map(r => +r.value),
        filteringRuleGroupIds: paramsValues.filteringRuleGroups.map(r => +r.value),
      });
      const userId = data.editUser?.user?.id || data.createUser?.user?.id;
      createActivity({
        entityType: 'User',
        entityId: +userId,
        action: data.editUser ? 'update' : 'add',
      });
      setRedirectUrl(USERS);
      notification.success(message);
    }catch (e) {
      notification.error(e);
    }
  }


  const handleFormSubmit = useCallback(
    async ({ values, form }) => {
      try {
        if(!values.isThirdPartyUser){
          setValues(values);
          setShowSaveConfirmPopup(true);
        }else{
          setShowSaveConfirmPopup(false);
          callSave(values);
        }
      } catch (e) {
        form.setErrors(parseFormErrors(e));
        notification.error(e);
      } finally {
        form.setSubmitting(false);
      }
    },
    [isNew],
  );

  return [redirectUrl, handleFormSubmit, showSaveConfirmPopup, setShowSaveConfirmPopup, callSave, paramValues];
};
